var _script, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBus84(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1000,
    width: 1718,
    viewBox: "0 0 1804 1050",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c9a2cd",
    d: "M0 0h1718v1000H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M576.002 876c-157 0-246-94-246-201 0-94 53-149 121-184-61-38-99-81-99-154 0-117 106-198 227-198 124 0 227 61 227 182 0 66-34 117-100 157 65 31 122 87 122 180 0 134-107 218-252 218zm-12-336c-46 18-92 64-92 119 0 58 38 113 106 113 67 0 104-47 104-103 0-64-58-99-118-129zm17-299c-55 0-90 34-90 83 0 58 58 89 103 108 37-17 77-58 77-102 0-49-32-89-90-89zM1324 713v147h-136V713H870V582l274-428h180v449h87v110h-87zm-136-435h-2c-3 12-23 55-51 99L991 603h197V278z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus84);
export default __webpack_public_path__ + "static/media/bus84.470636bad0f2ec9caeda13898ca27e52.svg";
export { ForwardRef as ReactComponent };